import React, { useState } from "react";
import "../pages/admin/styles.scss";
import { AiOutlinePhone, AiOutlineMail, AiOutlineUser } from "react-icons/ai";
import { useTranslation } from 'react-i18next';

function Footer(props) {
  const { adClass = "footer-2", container = "container" } = props;
  const { t } = useTranslation(); // Use o hook useTranslation para tradução
  const [openModalContact, setOpenModalContact] = useState(false);
  const [openModalRefund, setOpenModalRefund] = useState(false);

  return (
    <footer className={`footer ${adClass}`}>
      <div className="footer-bottom">
        <div style={{ display: "grid", placeItems: "center", gap: "10px", marginTop: "10px" }}>
          <p className="footer-copyright">
            {t("Footer.Copyright", {
              year: new Date().getFullYear(),
              app: "Groovoo",
            })}
          </p>
          <ul className="footer-menu">
            <li>
              <a
                href={process.env.PUBLIC_URL + "/terms.html"}
                target="_blank"
                rel="noreferrer"
              >
                {t("Footer.TermsOfUse")}
              </a>
            </li>
            <li>
              <a
                href={process.env.PUBLIC_URL + "/privacy.html"}
                target="_blank"
                rel="noreferrer"
              >
                {t("Footer.PrivacyPolicy")}
              </a>
            </li>
            <li>
              <a
                rel="noreferrer"
                href="/#"
                onClick={() => setOpenModalContact(!openModalContact)}
              >
                {t("Footer.ContactUs")}
              </a>
            </li>
            <li>
              <a href="/#" onClick={() => setOpenModalRefund(!openModalRefund)}>
                {t("Footer.RefundProcedure")}
              </a>
            </li>
            <li>
              <a
                href={process.env.PUBLIC_URL + "/delete-account-and-data.pdf"}
                target="_blank"
              >
                {t("Footer.DeleteAccountAndData")}
              </a>
            </li>
          </ul>

          <div style={{ display: "flex", gap: "10px", margin: "10px" }}>
            <a
              href="https://www.facebook.com"
              className="social-icon social-facebook"
              rel="noopener noreferrer"
              title="Facebook"
              target="_blank"
            >
              <i className="icon-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/groovooapp"
              className="social-icon social-instagram"
              rel="noopener noreferrer"
              title="Instagram"
              target="_blank"
            >
              <i className="icon-instagram"></i>
            </a>
          </div>
        </div>
      </div>
      {openModalContact && (
        <div>
          <div
            className="modal-back"
            onClick={() => setOpenModalContact(false)}
          ></div>
          <div className="modal-container">
            <div
              style={{
                display: "flex",
                width: "100%",
                fontSize: "2rem",
              }}
            >
              <i
                className="icon-close"
                onClick={() => setOpenModalContact(false)}
                style={{
                  width: "10px",
                  cursor: "pointer",
                  marginLeft: "auto",
                  marginTop: "10px",
                }}
              ></i>
            </div>
            <h3>{t("Footer.ContactUs")}</h3>
            <ul>
              <li>
                {" "}
                <AiOutlineUser /> {t("Footer.SupportTeam")}{" "}
              </li>
              <li>
                {" "}
                <AiOutlineMail /> support@groovooapp.com{" "}
              </li>
              <li>
                {" "}
                <AiOutlinePhone /> +1 (786) 962-8444{" "}
              </li>
            </ul>
          </div>
        </div>
      )}

      {openModalRefund && (
        <div>
          <div
            className="modal-back"
            onClick={() => setOpenModalRefund(false)}
          ></div>
          <div className="modal-container">
            <div
              style={{
                display: "flex",
                width: "100%",
                marginTop: "-40px",
                fontSize: "2rem",
              }}
            >
              <i
                className="icon-close"
                onClick={() => setOpenModalRefund(false)}
                style={{
                  width: "10px",
                  cursor: "pointer",
                  marginLeft: "auto",
                  marginTop: "10px",
                }}
              ></i>
            </div>
            <h3>{t("Footer.RefundProcedure")}</h3>
            <ul style={{ textAlign: "justify" }}>
              <li>
                {t("Footer.RefundProcedureText")}
              </li>
            </ul>
          </div>
        </div>
      )}
    </footer>
  );
}

export default React.memo(Footer);
